import i18nService from 'services/i18nService';


export const getFan5i18n = (translate: typeof i18nService.translate) => {
  return {
    'usp_title': translate('fan5.modal.broadcaster.usp.title'),
    'broadcaster_usp_1': translate('fan5.modal.broadcaster.usp.1'),
    'broadcaster_usp_2': translate('fan5.modal.broadcaster.usp.2'),
    'broadcaster_usp_3': translate('fan5.modal.broadcaster.usp.3'),
    'customer_usp_1': translate('fan5.modal.customer.usp.1'),
    'customer_usp_2': translate('fan5.modal.customer.usp.2'),
    'customer_usp_3': translate('fan5.modal.customer.usp.3'),
    'form_title': translate('fan5.modal.form.title'),
    'form_info': translate('fan5.modal.form.info'),
    'registration_success': translate('fan5.modal.registration.success'),
    'btn_open': translate('fan5.modal.btn.open'),
    'btn_continue': translate('fan5.modal.btn.continue'),
    'btn_submit': translate('fan5.modal.btn.submit'),
    'btn_cancel': translate('fan5.modal.btn.cancel'),
    'email': translate('fan5.modal.email'),
    'username': translate('fan5.modal.username'),
    'password': translate('fan5.modal.password'),
    'msg_has_account': translate('fan5.modal.msg.has.account'),
  };
};
